import { FC, useState } from 'react';
import { PaymentStatus } from '../models/TransferReservationPartial';
import { getPaymentStatusConfig } from '../constants/paymentStatusColors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



interface PaymentStatusHistoryProps {
  statusHistory: PaymentStatus[];
}

const PaymentStatusHistory: FC<PaymentStatusHistoryProps> = ({
  statusHistory
}) => {
  const [isHovered, setIsHovered] = useState(false);



  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="flex items-center justify-between gap-2 px-2 cursor-pointer "
        style={{
          transition: 'transform 0.3s ease-out',
          boxShadow: isHovered ? '0px 2px 5px rgba(59, 130, 246, 0.5)' : '0px 1px 3px rgba(59, 130, 246, 0.5)',
          border: isHovered ? '1px solid #3B82F6' : 'none',
          borderRadius: '8px'
        }}
      >
        <p
          className="text-md"
          style={{
            color: '#3B82F6'
          }}
        >
          Historial de Estados
        </p>

        <svg
          className="w-5 h-5 text-gray-500 transition-transform"
          fill="none"
          stroke='#3B82F6'
          viewBox="0 0 24 24"
          style={{
            transition: 'transform 0.3s ease-out',
            transform: isHovered ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      {/* Dropdown content with absolute positioning */}
      <div
        className="absolute top-full left-0 transition-all duration-300 ease-out z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-h-96 overflow-y-auto"
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          width: 'max-content',
          minWidth: '100%',
          opacity: isHovered ? 1 : 0,
          visibility: isHovered ? 'visible' : 'hidden',
          transform: isHovered ? 'translateY(0)' : 'translateY(-10px)',
          transition:
            'opacity 0.3s ease-out, visibility 0.3s ease-out, transform 0.3s ease-out',
          zIndex: 50
        }}
      >
        <div className="relative">
          {/* Timeline line - conectar todos los puntos si hay múltiples estados */}
          {statusHistory.length > 1 &&
            (() => {
              // Calcular altura y posición de la línea para conectar todos los puntos
              const itemHeight = 60; // Altura aproximada de cada item
              const iconOffset = 18; // Offset del icono desde el top del item (icono de 24px centrado)
              const lineTop = iconOffset; // Comenzar desde el centro del primer icono
              const lineHeight = (statusHistory.length - 1) * itemHeight; // Conectar todos los puntos

              return (
                <div
                  className="w-0.5 bg-gray-300"
                  style={{
                    position: 'absolute',
                    left: '11px',
                    top: `${lineTop}px`,
                    height: `${lineHeight}px`
                  }}
                ></div>
              );
            })()}

          {/* Timeline items */}
          <div className="space-y-4">
            {statusHistory.map((status, index) => {
              const statusConfig = getPaymentStatusConfig(status.status_name);

              return (
                <div key={index} className="relative flex items-start">
                  {/* Timeline icon */}

                  <FontAwesomeIcon
                    icon={statusConfig.icon}
                    style={{
                      color: statusConfig.color,
                      boxShadow: statusConfig.boxShadow,
                      borderRadius: '50%',
                      position: 'absolute',
                      left: '4px',
                      top: '5px'
                    }}
                  />

                  {/* Content */}
                  <div className="ml-10 flex-1">
                    <div className="bg-white">
                      <div className="flex items-center gap-4 mb-2">
                        <span
                          className="font-medium capitalize whitespace-nowrap"
                          style={{ color: statusConfig.color }}
                        >
                          {statusConfig.text}
                        </span>
                        <span className="text-sm text-gray-900 whitespace-nowrap">
                          {status.datetime.format('DD/MM/YYYY HH:mm')}
                        </span>
                      </div>

                      {status.status_detail && (
                        <p className="text-sm text-gray-600 mt-2 whitespace-nowrap">
                          {status.status_detail}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusHistory;
